import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import {
  IMPERIAL,
  METRIC,
  SYSTEMS_OF_MEASURE
} from '../../../constants/uom';
import Card from '../../shared/Card';
import UomBlock from '../../shared/UomBlock';
import styles from './styles.scss'
import classNames from "classnames";

const imperialUnits = SYSTEMS_OF_MEASURE[IMPERIAL];
const metricUnits = SYSTEMS_OF_MEASURE[METRIC];

const propTypes = {
  onSwitch: PropTypes.func,
  uom: PropTypes.string
};

const UomInfo = ({ onSwitch, uom }) =>  (
  <Card header='Units of Measure'>
    <Container className='px-0'>
      <Row className='text-center'>
        <Col md={4} className={`mb-3 ${styles.tab}`}>
          <div className={`${styles.button}`}>
            <input
              type='radio'
              id='imperial'
              className='mr-2 mb-4'
              name='uomRadio'
              value='Imperial'
              checked={uom === IMPERIAL}
              onChange={onSwitch}
            />
            <label className={`${styles.imperial} font-weight-bold`} htmlFor="imperial">Imperial</label>
          </div>
          <div className={`${styles.button}`}>
            <input
              className='mr-2 mb-4'
              id='metic'
              type='radio'
              name='uomRadio'
              value='Metric'
              checked={ uom === METRIC }
              onChange={onSwitch}
            />
            <label className={`${styles.metric} font-weight-bold`} htmlFor='metic'>Metric</label>
          </div>
          <UomBlock {...(uom === IMPERIAL ? imperialUnits : metricUnits)} active={true} />
        </Col>
      </Row>
    </Container>
  </Card>
);


UomInfo.propTypes = propTypes;

export default UomInfo;


// WEBPACK FOOTER //
// src/components/profile/UomInfo/index.jsx